export default "__VITE_PUBLIC_ASSET__9dc7b716__"